export const getTodayStr = () => {
  // 한국 시간 기준으로 현재 날짜 가져오기 (UTC + 9시간)
  const now = new Date();
  const koreaTime = new Date(now.getTime() + 9 * 60 * 60 * 1000);
  let year = koreaTime.getUTCFullYear();
  let month = koreaTime.getUTCMonth() + 1;
  let day = koreaTime.getUTCDate();
  
  // 오늘이 주말이면 가장 가까운 금요일로 이동
  const dayOfWeek = koreaTime.getUTCDay();
  if (dayOfWeek === 0) {
    // 일요일이면 2일 전 (금요일)
    koreaTime.setUTCDate(koreaTime.getUTCDate() - 2);
    year = koreaTime.getUTCFullYear();
    month = koreaTime.getUTCMonth() + 1;
    day = koreaTime.getUTCDate();
  } else if (dayOfWeek === 6) {
    // 토요일이면 1일 전 (금요일)
    koreaTime.setUTCDate(koreaTime.getUTCDate() - 1);
    year = koreaTime.getUTCFullYear();
    month = koreaTime.getUTCMonth() + 1;
    day = koreaTime.getUTCDate();
  }
  
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

// 전영업일을 반환하는 함수
export const getPreviousBusinessDayStr = () => {
  // 한국 시간 기준으로 현재 날짜 가져오기 (UTC + 9시간)
  const now = new Date();
  const koreaTime = new Date(now.getTime() + 9 * 60 * 60 * 1000);
  
  // 하루 전으로 이동
  koreaTime.setUTCDate(koreaTime.getUTCDate() - 1);
  
  // 주말이면 가장 가까운 금요일로 이동
  const dayOfWeek = koreaTime.getUTCDay();
  if (dayOfWeek === 0) {
    // 일요일이면 2일 더 전 (금요일)
    koreaTime.setUTCDate(koreaTime.getUTCDate() - 2);
  } else if (dayOfWeek === 6) {
    // 토요일이면 1일 더 전 (금요일)
    koreaTime.setUTCDate(koreaTime.getUTCDate() - 1);
  }
  
  const year = koreaTime.getUTCFullYear();
  const month = koreaTime.getUTCMonth() + 1;
  const day = koreaTime.getUTCDate();
  
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};
// 날짜를 YYYY.MM.DD (요일) 형식으로 포맷팅
export const formatDate = dateStr => {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const weekdays = ['일', '월', '화', '수', '목', '금', '토'];
  const weekday = weekdays[date.getDay()];
  return `${year}.${month}.${day} (${weekday})`;
};
